import { render, staticRenderFns } from "./StepFormItem.vue?vue&type=template&id=319561c8&"
import script from "./StepFormItem.vue?vue&type=script&lang=ts&"
export * from "./StepFormItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports